export function formatCurrency(value?: number | string): string {
  if (value === undefined || value === null || value === '') return ''
  const val = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(val)) return ''
  return val.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
